export default "__VITE_ASSET__Dr2reJsB__"